<template>
  <div class="event">
    <div class="event__type">{{ type }}</div>
    <img
      class="event__info-image"
      :src="image ? image : DEFAULT_ICON_URL"
      :alt="name"
    >
    <h6 class="event__info-name">{{ name }}</h6>
    <h6 class="event__info-description">{{ description }}</h6>
    <div class="event__actions">
      <a :href="to" class="btn btn_primary">Купить</a>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

const DEFAULT_ICON_URL = '/images/site/event-plug.png';

defineProps({
  type: String,
  name: String,
  description: String,
  image: String,
  to: {
    type: String,
    default: '',
  },
});
</script>

<style scoped lang="scss">
    .event {
        display: grid;
        grid-template-areas: 'type img name .' '. img description action';
        grid-template-columns: 1fr auto auto 1fr;
        grid-template-rows: auto auto;
        border-radius: 20px;
        padding: 16px;
        background-color: $black;
        gap: 14px;
        background-image: url('../../../../images/site/pattern.png');
        background-position: right;
        background-repeat: no-repeat;

        @media screen and (max-width: $screen-md-min) {
            grid-template-areas: 'type . description'
                                'img img img' 'name name name'
                                ' action action action';
            grid-template-columns: auto 1fr auto;
            grid-template-rows: repeat(4, auto);
        }

        &__type {
            grid-area: type;
            padding: 6px 18px;
            background-color: $grey;
            display: inline-block;
            border-radius: 16px;
            font-size: 10px;
            align-self: start;
            justify-self: start;
        }

        &__info-image {
            grid-area: img;
            height: 100px;
            width: 100px;
            border-radius: 12px;
            object-fit: contain;

            @media screen and (max-width: $screen-md-min) {
                justify-self: center;
            }
        }

        &__info-name {
            grid-area: name;
            align-self: end;
            color: $white;
            font-weight: 700;
            font-size: 24px;
            margin: 0;

            @media screen and (max-width: $screen-md-min) {
                justify-self: center;
            }
        }

        &__info-description {
            grid-area: description;
            color: $white;
            font-size: 16px;
            margin: 0;
        }

        &__actions {
            grid-area: action;
            align-self: end;
            justify-self: end;

            @media screen and (max-width: $screen-small) {
                justify-self: stretch;
            }

            a {
                display: inline-block;
                text-align: center;

                @media screen and (max-width: $screen-small) {
                    width: 100%;
                }
            }
        }
    }
</style>
